import { nameof } from '@core/helpers/extensions';

export class CardActivationHistoryTableFilterModel {
    public year: string = '';
    public month: string = '';
    get isFilteredByYear(): boolean { return this.isFilteredBy(nameof<CardActivationHistoryTableFilterModel>('year') ) }
    private isFilteredBy(fieldName: string): boolean { return this[fieldName] && this[fieldName] != ''; }
}